import { render } from "./PracticePrefences.vue?vue&type=template&id=3536e842"
import script from "./PracticePrefences.vue?vue&type=script&lang=js"
export * from "./PracticePrefences.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__